import { useEffect, useState } from 'react';
import { ChannelTile } from '../components/ChannelTile';
import { fetchChannels } from '../lib/bff';
import type { Channel } from '../data/mock';

/**
 * Channels — the full directory. Every section of the marketplace, one grid.
 * Channels load from the Provny BFF (fail-open to mock if unreachable).
 */
export function Channels() {
  const [channels, setChannels] = useState<Channel[] | null>(null);

  useEffect(() => {
    let active = true;
    fetchChannels().then((res) => {
      if (active) setChannels(res);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <main className="min-h-[100dvh] bg-provny-white text-provny-black dark:bg-provny-ink dark:text-provny-white">
      <div className="mx-auto max-w-7xl px-6 pb-20">
        <header className="pt-10">
          <h1 className="font-heading text-4xl font-black tracking-tight">Channels</h1>
          <p className="mt-2 text-provny-muted">Every corner of the marketplace, by the people who shape it.</p>
        </header>

        {channels && (
          <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {channels.map((channel) => (
              <ChannelTile key={channel.slug} channel={channel} />
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
